import * as React from 'react';
import { AppUser } from 'Src/views/App/App';
import * as Promise from 'bluebird';
import { Component } from 'react';
import * as propz from 'propz';
import {
  ColumnDefinition,
  getFilters,
  getOrder,
  getSearchFilter,
  getSearchOrder,
  getServerFieldSectionWhere,
  getServerQueryFilter,
  getPagesCount,
  isFilterExist,
  isSortExist,
  TABLE_SORT_DIRECTION,
} from 'Src/helpers/table';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE } from 'Src/consts/table';
import { parse } from 'query-string';
import { Loader } from 'Src/components/Loader/Loader';
import { Grid } from 'Src/components/Grid/Grid';
import { History, Location } from 'history';
import { SimpleModal } from '../../../../../../../components/SimpleModal/SimpleModal';
import {
  addSliderImages,
  deleteSliderImage,
  getAllSliderImages,
  getSliderImages,
  getSliderImagesCount,
  updateSliderImages,
} from '../../../../../../../services/superadmin/sliderImages';
import { SliderImageForm } from './SliderImageForm/SliderImageForm';
import { imagePublicCell } from '../../../../../../../helpers/cell';
import { Slider } from '../../../../../../../models/slider';
import { getSlider } from '../../../../../../../services/superadmin/sliders';
import { getIsActiveSliderImage } from '../../../../../../../helpers/accessor';
import { SIZE_UPLOAD_SLIDER_IMAGES } from '../../../../../../../consts/images';
import { convertToFilterWithPlus } from '../../../../../../../helpers/table';
import { LIMIT } from '../../../../../../../consts/table';

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Images',
    field: 'pic',
    isSort: true,
    type: FILTER_TYPE.NONE,
    cell: imagePublicCell,
  },
  {
    text: 'Link',
    field: 'link',
    isSort: true,
    type: FILTER_TYPE.NONE,
    accessor: ['link'],
  },
  {
    text: 'Activity',
    field: 'isActive',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getIsActiveSliderImage,
  },
];

interface State {
  items: any[];
  currentPage: number;
  selectedItems: any[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  isSelectAllChecked: boolean;
  total: number;
  basePath: string;
  sliderItem: Slider;
  isSliderImageFormModalOpen: boolean;
  isConfirmationModalOpen: boolean;
}

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

export class SliderImages extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isLoading: false,
      isSelectAllChecked: false,
      total: 0,
      basePath: '',
      sliderItem: undefined,
      isSliderImageFormModalOpen: false,
      isConfirmationModalOpen: false,
    };
  }

  getSliderId(): string {
    const { history } = this.props;
    const search = parse(history.location.search);
    const sliderId = search.slider as string;
    return sliderId;
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
    });
    this.setAdditionalItems().then(res => {
      this.setItems();
    });
  }

  setAdditionalItems() {
    const { user } = this.props;
    const sliderId = this.getSliderId();

    return getSlider(user, sliderId).then(slider => {
      this.setState({
        sliderItem: slider,
      });
      return true;
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true,
      });
      this.setItems();
    }
  }

  setItems() {
    const { history, user } = this.props;

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters(COLUMNS, search);

    const isShowFilter = isFilterExist(filters);
    const isDataFiltered = isFilterExist(filters);

    const where = getServerFieldSectionWhere(filters);

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter(page, where, order);

    const sliderId = this.getSliderId();

    const getItemsPromise = getSliderImages(user, sliderId, serverQueryFilter);
    const getItemsCountPromise = getSliderImagesCount(user, sliderId, where);

    const promises = [getItemsCountPromise, getItemsPromise];

    return Promise.all(promises).then(([countObj, items]) => {
      this.setState({
        currentPage: page,
        sortDirection: sortDirection as TABLE_SORT_DIRECTION,
        sortColumnsName: sortColumnsName,
        isShowFilter: isShowFilter,
        isDataFiltered: isDataFiltered,
        filters: filters,
        items: items,
        total: countObj.count,
        basePath: history.location.pathname,
        isLoading: false,
      });

      return true;
    });
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const sliderId = this.getSliderId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `slider=${sliderId}&${search.join('&')}`,
      state: history.location.state,
    });
  };

  onItemClick = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = selectedItems.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...selectedItems];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      selectedItems: selectedItemsUpdated,
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const selectedItemsNext = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: selectedItemsNext,
      isSelectAllChecked: true,
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true,
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(filters);

    const sliderId = this.getSliderId();

    getAllSliderImages(user, sliderId, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const selectedItemsNext = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: selectedItemsNext,
        isSelectAllChecked: true,
        isLoading: false,
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const sliderId = this.getSliderId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `slider=${sliderId}&${search.join('&')}`,
      state: history.location.state,
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue,
            },
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue,
            },
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value,
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue,
        };
      }
    }

    this.setState({
      filters: nextFilters,
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist(filters);

    const filtersConverted = convertToFilterWithPlus(filters);

    if (isFilter) {
      search.push(getSearchFilter(filtersConverted));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
    });

    const sliderId = this.getSliderId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `slider=${sliderId}&${search.join('&')}`,
      state: history.location.state,
    });
  };

  onClearFilterClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
    });

    const sliderId = this.getSliderId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `slider=${sliderId}`,
      state: history.location.state,
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter,
    });
  };

  goBack = () => {
    const { history, location } = this.props;
    const { state } = location;
    const { search } = state as any;
    const sliderId = this.getSliderId();

    history.push({
      pathname: '/sliders',
      search: search,
      state: { sliderId: sliderId },
    });
  };

  onCancelButtonClick = () => {
    this.setState({
      isSliderImageFormModalOpen: false,
    });
  };

  onSubmitForm = data => {
    const { selectedItems, total } = this.state;
    const { user } = this.props;
    const sliderId = this.getSliderId();
    this.setState({
      isLoading: true,
    });

    if (selectedItems.length === 1) {
      const imageId = selectedItems[0].id;
      updateSliderImages(user, sliderId, imageId, data).then(res => {
        this.setState({
          isSliderImageFormModalOpen: false,
          selectedItems: [res],
          isSelectAllChecked: false,
        });
        this.setItems();
      });
    } else {
      addSliderImages(user, sliderId, data).then(res => {
        const lastPage = getPagesCount(total + 1, LIMIT);
        this.setState({
          isSliderImageFormModalOpen: false,
          selectedItems: [res],
          isSelectAllChecked: false,
        });
        this.setCurrentPageParams(lastPage);
        this.setItems();
      });
    }
  };

  renderFormModal() {
    const { isSliderImageFormModalOpen, selectedItems, sliderItem } = this.state;
    const { user } = this.props;
    const sliderType = propz.get(sliderItem, ['type'], SIZE_UPLOAD_SLIDER_IMAGES.MAIN_SLIDER);

    if (selectedItems.length === 1) {
      const sliderImage = selectedItems[0];
      return (
        <SimpleModal isOpen={isSliderImageFormModalOpen}>
          <SliderImageForm
            sliderImage={sliderImage}
            sliderType={sliderType}
            onCancel={this.onCancelButtonClick}
            onSubmit={this.onSubmitForm}
            user={user}
          />
        </SimpleModal>
      );
    } else {
      return (
        <SimpleModal isOpen={isSliderImageFormModalOpen}>
          <SliderImageForm
            sliderType={sliderType}
            onCancel={this.onCancelButtonClick}
            onSubmit={this.onSubmitForm}
            user={user}
          />
        </SimpleModal>
      );
    }
  }

  onCreateSliderImageClick = () => {
    this.setState({
      isSliderImageFormModalOpen: true,
    });
  };

  onEditSliderImageClick = () => {
    this.setState({
      isSliderImageFormModalOpen: true,
    });
  };

  showConfirmationModal = () => {
    this.setState({
      isConfirmationModalOpen: true,
    });
  };

  hideConfirmationModal = () => {
    this.setState({
      isConfirmationModalOpen: false,
    });
  };

  renderConfirmationModal(): React.ReactNode {
    const { isConfirmationModalOpen, selectedItems } = this.state;

    return (
      <SimpleModal
        isOpen={isConfirmationModalOpen}
        title={'Confirmation'}
        body={`Are you sure you want to remove ${selectedItems.length === 1 ? 'image' : 'images'}?`}
        buttonText={'Remove'}
        buttonCancelText={'Cancel'}
        onButtonClick={this.onDeleteSliderImageClick}
        onCloseClick={this.hideConfirmationModal}
      />
    );
  }

  onDeleteSliderImageClick = () => {
    const { selectedItems } = this.state;
    const { user } = this.props;

    this.setState({
      isLoading: true,
      isConfirmationModalOpen: false,
    });

    const sliderId = this.getSliderId();

    Promise.all(selectedItems.map(selectedItem => deleteSliderImage(user, sliderId, selectedItem.id))).then(res => {
      this.setState({
        selectedItems: [],
        isSelectAllChecked: false,
      });

      this.setItems();
    });
  };

  render() {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      isLoading,
      isSelectAllChecked,
      currentPage,
      total,
      sliderItem,
      isSliderImageFormModalOpen,
      isConfirmationModalOpen,
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const classes = isSliderImageFormModalOpen || isConfirmationModalOpen ? 'mt-3 modal-open' : 'mt-3';

    const actionItems = [
      {
        itemText: 'Create slider image',
        onItemClick: this.onCreateSliderImageClick,
        isActive: selectedItems.length === 0,
      },
      {
        itemText: 'Edit slider image',
        onItemClick: this.onEditSliderImageClick,
        isActive: selectedItems.length === 1,
      },
      {
        itemText: selectedItems.length === 1 ? 'Delete slider image' : 'Delete slider images',
        onItemClick: this.showConfirmationModal,
        isActive: selectedItems.length > 0,
      },
    ];

    const filterOptions = {};

    const gridTitle = typeof sliderItem !== 'undefined' ? `${sliderItem.name} / Slider images` : '';

    return (
      <div className={classes}>
        {/*Place for render modal windows*/}
        {this.renderFormModal()}
        {this.renderConfirmationModal()}
        <div className="row">
          <div className="col-md-12">
            <Grid
              dataItems={items}
              filters={filters}
              currentPage={currentPage}
              total={total}
              isSelectAllChecked={isSelectAllChecked}
              isDataFiltered={isDataFiltered}
              sortDirection={sortDirection}
              sortColumnsName={sortColumnsName}
              isShowFilter={isShowFilter}
              dataItemsSelected={selectedItems}
              columns={COLUMNS}
              actionItems={actionItems}
              options={filterOptions}
              onItemClick={this.onItemClick}
              onSortClick={this.onTableSortClick}
              onApplyFilterClick={this.onApplyFilterClick}
              onClearFilterClick={this.onClearFilterClick}
              onTableFilterChange={this.onTableFilterChange}
              onTableFilterClick={this.onTableFilterClick}
              setCurrentPageParams={this.setCurrentPageParams}
              onSelectAllClick={this.onSelectAllClick}
              onSelectAllOnPageClick={this.onSelectAllOnPageClick}
              onUnselectAllClick={this.onUnselectAllClick}
              gridTitle={gridTitle}
              goBack={this.goBack}
            />
          </div>
        </div>
      </div>
    );
  }
}
